export function processRolesArray(
  roles: string,
  currentCustomerId: string | null,
  currentSiteId: string | null
) {
  // Entries look like `{customerId}:{siteId or *}:{role}:{status}`
  const data: string[] = JSON.parse(roles);

  const matchingRole = data.find((item) => {
    // eslint-disable-next-line
    const [customerId, siteId, role] = item.split(':');

    if (siteId === '*' && customerId === currentCustomerId) {
      return true;
    }

    if (currentSiteId && currentCustomerId) {
      if (customerId === currentCustomerId && siteId === currentSiteId) {
        return true;
      }
    }

    return false;
  });

  return matchingRole ? matchingRole.split(':').slice(-2, -1)[0] || 'NO_ACCESS' : 'NO_ACCESS';
}
